import { mergeSx } from "ui/merge-sx";
import { Tooltip } from "ui/tooltip/tooltip";
import {
  TRUNCATED_TEXT_TOOLTIP_MAX_WIDTH_PX,
  TRUNCATED_TEXT_TOOLTIP_OFFSET_PX,
  TRUNCATED_TEXT_TOOLTIP_PLACEMENT,
} from "ui/truncated-text/truncated-text.constants";
import {
  TRUNCATED_TEXT_LABEL_SX,
  TRUNCATED_TEXT_TOOLTIP_SX,
  TRUNCATED_TEXT_WRAPPER_SX,
} from "ui/truncated-text/truncated-text.styles";
import { type TruncatedTextProps } from "ui/truncated-text/truncated-text.types";
import { useTruncatedText } from "ui/truncated-text/use-truncated-text";
import { Typography } from "ui/typography/typography";

export const TruncatedText = ({ text, wrapperSx, sx, ref, ...rest }: TruncatedTextProps) => {
  const { textRef, isTruncated } = useTruncatedText({ ref });

  return (
    <Tooltip
      label={text}
      placement={TRUNCATED_TEXT_TOOLTIP_PLACEMENT}
      offset={TRUNCATED_TEXT_TOOLTIP_OFFSET_PX}
      suppressed={!isTruncated}
      maxWidth={TRUNCATED_TEXT_TOOLTIP_MAX_WIDTH_PX}
      sx={TRUNCATED_TEXT_TOOLTIP_SX}
      wrapperSx={mergeSx(TRUNCATED_TEXT_WRAPPER_SX, wrapperSx)}>
      <Typography
        {...rest}
        ref={textRef}
        component="span"
        variant="inherit"
        noWrap
        sx={mergeSx(TRUNCATED_TEXT_LABEL_SX, sx)}>
        {text}
      </Typography>
    </Tooltip>
  );
};
